import { ReactNode } from 'react'

import { Global } from '@emotion/react'

import { processEnv } from '~/utils/env'

import CheckoutFooter from '~/components/Checkout/CheckoutPage/CheckoutFooter'
import { FestivalCodesEnum } from '~/generated/graphql'
import globalStyle from '~/theme/globalStyle'

import Head from '../Head'

type CheckoutLayoutProps = {
  children: ReactNode
  hasFooter?: boolean
  festivalCode?: FestivalCodesEnum
}

export default function CheckoutLayout({ children, hasFooter = true, festivalCode }: CheckoutLayoutProps) {
  const isGW = festivalCode === FestivalCodesEnum.Gw

  return (
    <>
      <Head>
        {isGW && processEnv.META_PIXEL_ID && (
          <>
            <script
              async
              dangerouslySetInnerHTML={{
                __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,"script",
            "https://connect.facebook.net/en_US/fbevents.js");
            fbq("init", "${processEnv.META_PIXEL_ID}");
            fbq('track', 'InitiateCheckout');`,
              }}
            />
            <noscript>
              <img
                height='1'
                width='1'
                style={{ display: 'none' }}
                src={`https://www.facebook.com/tr?id=${processEnv.META_PIXEL_ID}&ev=PageView&noscript=1`}
              />
            </noscript>
          </>
        )}
      </Head>
      <Global styles={globalStyle} />
      <div>{children}</div>
      {hasFooter && <CheckoutFooter />}
    </>
  )
}
